import { DiscountCategoriesMap } from '@/entities/catalog-discount/schema/discount-categories.schema'
import { DiscountProductDetail } from '@/entities/catalog-discount/schema/discount-product-detail.schema'
import { ProductPayments } from '@/entities/Payments/model/types/PaymentSchema'

import { nextfetch, nextfetchdata } from '@/shared/api/nextfetch'
import { ServerResponse } from '@/shared/types/common'

export const fetchDiscountCategories = async (regionCookies: string = ``): Promise<DiscountCategoriesMap | void> =>
	nextfetchdata<DiscountCategoriesMap>(`discount/categories`, {
		cookie: regionCookies,
		credentials: `include`,
		cache: `no-store`
	})

export const fetchDiscountFilterSefUrl = (categoryCode: string, filterUrl: string = ``): Promise<string | void> =>
	nextfetchdata<string>(`discount/filter/${categoryCode}/sef-url`, {
		params: {
			filter: filterUrl
		}
	})

export const fetchDiscountProduct = async (
	id: string,
	regionCookies: string = ``
): Promise<DiscountProductDetail | void> =>
	nextfetchdata<DiscountProductDetail>(`discount/products/${id}`, {
		cookie: regionCookies,
		credentials: `include`,
		cache: `no-store`
	})

export const fetchDiscountProductPayments = async (
	id: string,
	regionCookies: string = ``
): Promise<ServerResponse<ProductPayments>> =>
	nextfetch<ServerResponse<ProductPayments>>(`discount/products/${id}/payments`, {
		cookie: regionCookies,
		credentials: `include`,
		cache: `no-store`
	})

export const fetchDiscountProductDescription = async (
	id: string,
	regionCookies: string = ``
): Promise<string | undefined> => {
	const response = await nextfetch<ServerResponse<{ DETAIL_TEXT: string }>>(`discount/products/${id}/description`, {
		cookie: regionCookies,
		credentials: `include`,
		cache: `no-store`
	})

	return response?.data?.DETAIL_TEXT
}
